import dotenv from 'dotenv'
import { dirname, join } from 'path'
import { fileURLToPath } from 'url'
import { IAppConfig, ResponseFormat } from '../../index.js'
import {
  DEFAULT_API_KEY,
  DEFAULT_BASE_URL,
  DEFAULT_DATA_DIR,
  DEFAULT_DEBUG,
  DEFAULT_RESPONSE_FORMAT,
  DEFAULT_TRIMMED_RESPONSES
} from '../constants/index.js'

const __dirname = dirname(fileURLToPath(import.meta.url))

/**
 * Creates an object containing the necessary configuration options for the
 * library to function properly. Attempts to set each value to the value of its
 * corresponding environment variable, falling back to the default value if the
 * environment variable is not set.
 *
 * For example, `apiKey` is set either to the value of `process.env.API_KEY` or
 * to the value of `DEFAULT_API_KEY` if `process.env.API_KEY` is not set.
 *
 * @returns The created appConfig object.
 */
export function getAppConfig(): IAppConfig {
  /**
   * Attempt to parse a `.env` file in the root directory of the project. If the
   * file exists, then the values in the file will be assigned as environment
   * variables.
   */
  dotenv.config({ path: join(__dirname, '..', '..', '..', '.env') })

  return {
    apiKey: process.env.API_KEY || DEFAULT_API_KEY,
    baseUrl: process.env.BASE_URL || DEFAULT_BASE_URL,
    dataDir: process.env.DATA_DIR || DEFAULT_DATA_DIR,
    debug: process.env.DEBUG === 'true' || DEFAULT_DEBUG,
    responseFormat: (process.env.RESPONSE_FORMAT as ResponseFormat) || DEFAULT_RESPONSE_FORMAT,
    trimmedResponses: process.env.TRIMMED_RESPONSES === 'true' || DEFAULT_TRIMMED_RESPONSES
  }
}
